var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 2.53133V34.5313C0.898337 34.8872 0.993187 35.2366 1.1732 35.5436C1.35321 35.8506 1.61187 36.104 1.92249 36.2776C2.2331 36.4513 2.58442 36.5389 2.94021 36.5315C3.29599 36.524 3.64335 36.4218 3.94644 36.2353L29.9464 20.2353C30.2376 20.0564 30.4781 19.8058 30.6449 19.5075C30.8118 19.2092 30.8994 18.8731 30.8994 18.5313C30.8994 18.1895 30.8118 17.8535 30.6449 17.5552C30.4781 17.2568 30.2376 17.0063 29.9464 16.8273L3.94644 0.827325C3.64335 0.640855 3.29599 0.53863 2.94021 0.531198C2.58442 0.523766 2.2331 0.611396 1.92249 0.785047C1.61187 0.958698 1.35321 1.21208 1.1732 1.51905C0.993187 1.82602 0.898337 2.17547 0.898438 2.53133Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleIcon);
export default __webpack_public_path__ + "static/media/play-circle-icon.1147bde7f41959befb34077978f5a9b1.svg";
export { ForwardRef as ReactComponent };